jQuery( document ).ready(function() {
	// Check if component is added to the page
    if( jQuery('section.accordions').length ) {
        const $ = jQuery;
        let $accordionheader = $(".accordion__header");

        $accordionheader.on("click", function(e) {
            $(this).toggleClass("open");
            $(this).parent().find(".accordion__body").slideToggle();
        });
    }
});